module.exports = __webpack_public_path__ + "static/media/14.178e2001.jpg";